export default "/images/vendor/flag-icon-css/flags/4x3/tj.svg?b32f7c017787f0d8579b5aeab5923fb4";